import { Document, PipeReview } from 'types/common';
import { PIPE_REVIEW_STATUS } from 'utils/constants';
import DateTime from 'utils/datetime';

export const getPipeTask = (task: string) => {
  switch (task) {
    case 'Pipe Installation':
      return 'PIPE_INSTALLATION';
    case 'Drying Event':
      return 'DRYING_EVENT';
    case 'Drying Event 1':
      return 'DRYING_EVENT';
    case 'Drying Event 2':
      return 'SECOND_DRYING_EVENT';
    case 'Drying Event 3':
      return 'THIRD_DRYING_EVENT';
    default:
      return task;
  }
};

/*  Get the right Status based on Pipe Task and set to overdue
    if Pipe picture has been submitted for over 15 minutes */
export const getPipeStatus = (data: PipeReview) => {
  const status = (() => {
    switch (data.dryingEventTaskName) {
      case 'Pipe Installation':
        return data.installationImageReviewStatus;
      case 'Drying Event':
      case 'Drying Event 1':
        return data.reviewStatus;
      case 'Drying Event 2':
        return data.secondReviewStatus;
      case 'Drying Event 3':
        return data.thirdReviewStatus;
      default:
        return '';
    }
  })();

  if (
    (status === PIPE_REVIEW_STATUS.IN_REVIEW ||
      status === PIPE_REVIEW_STATUS.PENDING) &&
    !!getPipeDate(data) &&
    DateTime.diff(DateTime.now(), getPipeDate(data), 'minutes') > 15
  ) {
    return PIPE_REVIEW_STATUS.OVERDUE;
  }
  return status;
};

// Get the right Date based on Pipe Task
export const getPipeDate = (data: PipeReview) => {
  switch (data.dryingEventTaskName) {
    case 'Pipe Installation':
      return data.installationDate;
    case 'Drying Event':
    case 'Drying Event 1':
      return data.servicedDate;
    case 'Drying Event 2':
      return data.secondServicedDate;
    case 'Drying Event 3':
      return data.thirdServicedDate;
    default:
      return '';
  }
};

export const getReason = (data: PipeReview) => {
  switch (data.dryingEventTaskName) {
    case 'Pipe Installation':
      return data.pipeInstallationReason;
    case 'Drying Event':
    case 'Drying Event 1':
      return data.dryingEventReason;
    case 'Drying Event 2':
      return data.secondDryingEventReason;
    case 'Drying Event 3':
      return data.thirdDryingEventReason;
    default:
      return '';
  }
};

export const getPipePictureList = (
  data?: { documentList?: Document[] },
  customField?: any[],
) => {
  const list = customField ?? data?.documentList ?? [];

  const nonRejectedPictures = list.filter(
    (val) =>
      val.status !== PIPE_REVIEW_STATUS.REJECTED &&
      val.status !== PIPE_REVIEW_STATUS.AUTO_REJECTED,
  );
  const rejectedPictures = list.filter(
    (val) =>
      val.status === PIPE_REVIEW_STATUS.REJECTED ||
      val.status === PIPE_REVIEW_STATUS.AUTO_REJECTED,
  );

  return {
    nonRejectedPictures,
    rejectedPictures,
    pictureList: list,
  };
};

type GroupedPictures = {
  urls?: string[];
  reason?: string;
  date?: string;
  reviewedBy?: string;
};

export const getGroupedPictures = (images: Document[]) => {
  const groupedPictures: GroupedPictures[] = [];
  images.forEach((image) => {
    const date = new Date(image.createdDate ?? '').toISOString().split('T')[0];
    const index = groupedPictures.findIndex(
      (picture) => picture.date === date && picture.reason === image.reason,
    );
    if (index > -1) {
      groupedPictures?.[index]?.urls?.push(image.url);
    } else {
      groupedPictures.push({
        urls: [image.url],
        reason: image.reason,
        date: date,
        reviewedBy: image.reviewedBy,
      });
    }
  });

  return groupedPictures;
};
